module.exports = __webpack_public_path__ + "static/img/1047_small.d4a1954.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1047_small.png
// module id = Fcqo
// module chunks = 1